import React from "react";

type SkipOptionalStepProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
};

export function SkipOptionalStep({
  checked,
  onChange,
  children,
}: SkipOptionalStepProps) {
  return (
    <div className="p-4">
      <div
        className="optional-record"
        style={{
          padding: "16px",
          backgroundColor: "#f8f9fa",
          marginBottom: "20px",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            margin: 0,
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            style={{
              width: "18px",
              height: "18px",
              marginRight: "10px",
              cursor: "pointer",
            }}
          />
          <span style={{ fontSize: "14px", fontWeight: 500 }}>
            Enter this record later.
          </span>
        </label>
        {!checked && (
          <p
            style={{
              fontSize: "13px",
              color: "#666",
              margin: "8px 0 0 28px",
            }}
          >
            <span style={{ color: "#b02a37" }}>*</span> Marks a required field.
            These fields will need to be filled in before you can submit all
            steps of the form.
          </p>
        )}
      </div>

      {!checked && children}
    </div>
  );
}
